import { useTranslation } from 'react-i18next';
import { useDocumentParams } from 'app/router/params';
import { useEffect, useState, ChangeEvent } from 'react';

import { usePageNumberingSave } from 'entities/document';
import { useSetEditorDocument } from 'app/api/documents/useEditorData';
import { useGetDocumentBySuperId } from 'entities/document';

interface PageNumberingProps {
  documentId?: string;
}

export const PageNumbering = (_props: PageNumberingProps) => {
  const { t } = useTranslation('project-details');

  const setEditorDocument = useSetEditorDocument();
  const { documentId } = useDocumentParams();
  const { data: pDocument } = useGetDocumentBySuperId(documentId);
  const { mutateAsync: savePageNumbering } = usePageNumberingSave();
  const [pageNumbering, setPageNumbering] = useState<{ showFrom?: number; countFrom?: number }>(pDocument?.content?.pageNumbering || {});

  useEffect(() => {
    setPageNumbering(pDocument?.content?.pageNumbering || {});
  }, [pDocument]);

  const handleShowFrom = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = { showFrom: parseInt(e.target.value), countFrom: pageNumbering.countFrom ?? 1 };
    setPageNumbering(newValue);

    savePageNumbering({ documentSuperId: documentId, documentRevisionId: pDocument?.revisionId, pageNumbering: newValue }).then((res) => {
      setEditorDocument(res.data);
    });
  };

  const handleCountFrom = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = { showFrom: pageNumbering.showFrom ?? 1, countFrom: parseInt(e.target.value) };
    setPageNumbering(newValue);

    savePageNumbering({ documentSuperId: documentId, documentRevisionId: pDocument?.revisionId, pageNumbering: newValue }).then((res) => {
      setEditorDocument(res.data);
    });
  };

  return (
    <>
      <h2 className="mb-3">{t('page-numbering.title')}</h2>
      <div className="row">
        <div className="col">
          <label className="form-label">{t('page-numbering.show-from')}</label>
          <input value={pageNumbering.showFrom || 1} onChange={handleShowFrom} className="form-control" type="number" min={1} />
        </div>

        <div className="col">
          <label className="form-label">{t('page-numbering.count-from')}</label>
          <input value={pageNumbering.countFrom || 1} onChange={handleCountFrom} className="form-control" type="number" min={1} />
        </div>
      </div>
    </>
  );
};
